import { Loc } from '../engine/core/localization.js';
import { AddDiv, AddDomElement } from '../engine/viewer/domutils.js';
import { Embed } from './embed.js';
import { Website } from './website.js';
import { SetEventHandler, HandleEvent } from './eventhandler.js';
import { PluginType, RegisterPlugin } from './pluginregistry.js';
import { ButtonDialog, ProgressDialog } from './dialog.js';
import { ShowMessageDialog } from './dialogs.js';

import * as Engine from '../engine/main.js';
export { Engine };

import './css/icons.css';
import './css/themes.css';
import './css/core.css';
import './css/controls.css';
import './css/dialogs.css';
import './css/treeview.css';
import './css/panelset.css';
import './css/navigator.css';
import './css/sidebar.css';
import './css/website.css';
import './css/embed.css';

export const UI = {
    ButtonDialog,
    ProgressDialog,
    ShowMessageDialog,
    HandleEvent,
    Loc
};

export function SetWebsiteEventHandler (eventHandler)
{
    SetEventHandler (eventHandler);
}

export function RegisterHeaderPlugin (plugin)
{
    RegisterPlugin (PluginType.Header, plugin);
}

export function RegisterToolbarPlugin (plugin)
{
    RegisterPlugin (PluginType.Toolbar, plugin);
}

export function StartWebsite ()
{
    window.addEventListener ('load', () => {
        if (window.self !== window.top) {
            let noEmbeddingDiv = AddDiv (document.body, 'noembed');
            AddDiv (noEmbeddingDiv, null, Loc ('Embedding Online 3D Viewer in an iframe is not supported.'));
            let link = AddDomElement (noEmbeddingDiv, 'a', null, Loc ('Open Online 3D Viewer'));
            link.target = '_blank';
            link.href = window.self.location;
            return;
        }

        document.getElementById ('intro_dragdrop_text').innerHTML = Loc ('Drop your 3D Model Here');
        document.getElementById ('intro_formats_title').innerHTML = Loc ('Example file formats');

        let cleanupApiUrl = window.location.pathname.indexOf ('/website/') !== -1 ? '../api/cleanup.php' : 'api/cleanup.php';
        fetch (cleanupApiUrl, {
            method : 'GET',
            cache : 'no-store'
        }).catch (() => {
        });

        let fileInput = document.getElementById ('open_file');
        let browseButton = document.getElementById ('rionick_browse_button');
        let uploadButton = document.getElementById ('rionick_upload_button');
        let resetButton = document.getElementById ('rionick_reset_button');
        let accentButton = document.getElementById ('rionick_accent_button');
        let introDiv = document.getElementById ('intro');
        let openFileBrowser = () => {
            fileInput.click ();
        };
        browseButton.addEventListener ('click', openFileBrowser);
        uploadButton.addEventListener ('click', openFileBrowser);
        resetButton.addEventListener ('click', () => {
            window.location.href = window.location.pathname;
        });
        accentButton.addEventListener ('click', () => {
            document.body.classList.toggle ('rionick_accent_alt');
            document.documentElement.classList.toggle ('rionick_accent_alt');
        });

        introDiv.addEventListener ('dragenter', () => {
            document.body.classList.add ('rionick_drag_over');
        });
        introDiv.addEventListener ('dragleave', (ev) => {
            if (!introDiv.contains (ev.relatedTarget)) {
                document.body.classList.remove ('rionick_drag_over');
            }
        });
        window.addEventListener ('drop', () => {
            document.body.classList.remove ('rionick_drag_over');
        });

        let website = new Website ({
            headerDiv : document.getElementById ('header'),
            headerButtonsDiv : document.getElementById ('header_buttons'),
            toolbarDiv : document.getElementById ('toolbar'),
            mainDiv : document.getElementById ('main'),
            introDiv : introDiv,
            introContentDiv : document.getElementById ('intro_content'),
            fileNameDiv : document.getElementById ('main_file_name'),
            leftContainerDiv : document.getElementById ('main_left_container'),
            navigatorDiv : document.getElementById ('main_navigator'),
            navigatorSplitterDiv : document.getElementById ('main_navigator_splitter'),
            rightContainerDiv : document.getElementById ('main_right_container'),
            sidebarDiv : document.getElementById ('main_sidebar'),
            sidebarSplitterDiv : document.getElementById ('main_sidebar_splitter'),
            viewerDiv : document.getElementById ('main_viewer'),
            correctionButton : document.getElementById ('rionick_correction_button'),
            correctionMarkersDiv : document.getElementById ('rionick_correction_markers'),
            correctionPanelDiv : document.getElementById ('rionick_correction_panel'),
            mobileNavigationDiv : document.getElementById ('rionick_mobile_nav'),
            mobileScrimButton : document.getElementById ('rionick_mobile_scrim'),
            fileInput : fileInput
        });
        website.Load ();
    });
}

export function StartEmbed ()
{
    window.addEventListener ('load', () => {
        let embed = new Embed ({
            viewerDiv : document.getElementById ('embed_viewer'),
            websiteLinkDiv : document.getElementById ('website_link')
        });
        embed.Load ();
    });
}
